import { getPrefillQueryKeyFromUuid, parseInputFromFormData } from '../../common/utils'
import QUERY_PREFILL from '../queries/mortgage-widget-prefill-submission'
import QUERY_SUBMISSION from '../queries/mortgage-widget-submission'
import MUTATION_PRODUCTS from '../mutations/mortgage-widget-fetch-products'

const querySubmission = (client, uuid, productTypes) => new Promise((resolve, reject) => {
  client.query({
    query: QUERY_SUBMISSION,
    variables: { uuid, productTypes },
    fetchPolicy: 'network-only',
  }).then(({ data }) => resolve(data.mortgageWidgetSubmission)).catch(err => reject(err))
})

const getPurchasePrefillData = (client, uuid, zipCode, productTypes, loanType) => new Promise((resolve, reject) => {
  client.query({
    query: uuid ? QUERY_SUBMISSION : QUERY_PREFILL,
    variables: uuid ? { uuid, productTypes } : { vertical: 'purchase', zipCode, productTypes, loanType },
  }).then(({ data }) => {
    resolve(data[getPrefillQueryKeyFromUuid(uuid)])
  }).catch(err => {
    reject(err)
  })
})

const getRefinancePrefillData = (client, uuid, zipCode, productTypes, loanType) => new Promise((resolve, reject) => {
  client.query({
    query: uuid ? QUERY_SUBMISSION : QUERY_PREFILL,
    variables: uuid ? { uuid, productTypes } : { vertical: 'refinance', zipCode, productTypes, loanType },
  }).then(({ data }) => {
    resolve(data[getPrefillQueryKeyFromUuid(uuid)])
  }).catch(err => {
    reject(err)
  })
})

const getNewSubmissionProducts = (client, formData, productTypes) => new Promise((resolve, reject) => {
  client.mutate({
    mutation: MUTATION_PRODUCTS,
    variables: {
      input: parseInputFromFormData(formData),
      productTypes,
    },
  }).then(({ data }) => {
    const { mortgageWidgetFetchProducts } = data
    const { status, products, uuid, vertical: loanType, ...rest } = mortgageWidgetFetchProducts

    if (status === 'responseReceived') {
      resolve({ uuid, products, loanType, ...rest })
    }

    const querySubmissionInterval = setInterval(() => {
      querySubmission(client, uuid, productTypes).then(({ status: queryStatus, products: queryProducts }) => {
        if (queryStatus === 'responseReceived' || queryStatus === 'noOffers' || queryStatus === 'error') {
          clearInterval(querySubmissionInterval)
          resolve({ uuid, products: queryProducts, loanType, ...rest })
        }
      })
    }, 2000)
  })
    .catch(err => reject(err))
})

export {
  querySubmission,
  getPurchasePrefillData,
  getRefinancePrefillData,
  getNewSubmissionProducts,
}
